import React from 'react';
import { ONLINE, OFFLINE } from 'assets/icons';
import PropTypes from 'prop-types';
import { useOfflineMode } from 'hooks';
import * as Styled from './styles';

// Reflects the user's offline-mode intent (the flag we store in IDB) rather
// than the browser's network status. Going offline is an explicit action now,
// so the indicator mirrors that choice even when network is still available.
function OnlineIndicator() {
  const offlineMode = useOfflineMode();
  const isOnline = !offlineMode;

  const Item = ({ status }) => {
    const itemData = {
      icon: status ? ONLINE : OFFLINE,
      text: status ? 'Online' : 'Offline',
      alt: status ? 'You are online' : 'You are offline',
    };
    return (
      <Styled.Item>
        <Styled.Icon data-html2canvas-ignore src={itemData.icon} alt={itemData.alt} sizes={[12, 12]} />
        <Styled.Text data-html2canvas-ignore isOnline={status}>
          {itemData.text}
        </Styled.Text>
      </Styled.Item>
    );
  };

  Item.propTypes = {
    status: PropTypes.bool.isRequired,
  };

  return (
    <Styled.Wrapper>
      <Item status={isOnline} />
    </Styled.Wrapper>
  );
}

export default OnlineIndicator;
